export default __webpack_public_path__ + "static/media/q11_step3.ea6df482.png";